
import { helpTexts } from "@/constants";
import Vue from "vue";

export default Vue.extend({
  name: "Help",
  data: () => ({}),
  computed: {
    textArr() {
      return helpTexts.filter(item => item.active);
    }
  }
});
